export default "__VITE_ASSET__BEBC9dWU__"